import React from "react";

import { styled } from "@mui/material";
import { Outlet } from "react-router-dom";

const Root = styled("div")(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(0, 4),
  height: "100%",
}));

const DatabasePage: React.FC = () => {
  return (
    <Root>
      <Outlet />
    </Root>
  );
};

export default DatabasePage;
